import styled from 'styled-components';
import Text from '../../ToolkitV2/Text/Text';

export const ReviewCount = styled(Text)`
  white-space: nowrap;
  vertical-align: text-bottom;
`;

export const AverageText = styled(Text)`
  white-space: pre;
`;
